module.exports = __webpack_public_path__ + "media/images/common/print_btn_s-7c322ddf9d42af6437c81300d470a8be.png";